import {Injectable} from '@angular/core';
import {ComponentBase} from '../../../component-base';
import {IMouseRelease, IDoubleClick} from '../Interfaces';
import {DrawingsHolderService} from '../drawings-holder.service';
import {PositionCalculatorService} from '../position-calculator.service';
import {Arc} from '../object3D/Arc';
import { SelectComponent } from '.';

declare const THREE: any;

@Injectable()
export class DrawArcComponent extends ComponentBase implements IMouseRelease, IDoubleClick {
  dblclick(e: MouseEvent): boolean {
    this.drawings.canvas.remove(this.arc);
    this.arc = undefined;
    this.selectComponent.enable();
    this.selectComponent.mouseUp(e);
    this.disable();
    return true;
  }

  private firstClick = true;
  private arc: Arc | undefined;

  constructor(
    private drawings: DrawingsHolderService,
    private positionCalculator: PositionCalculatorService,
    private selectComponent: SelectComponent
    ) {
    super();
    this.disable();
  }

  mouseUp(e: MouseEvent): boolean {
    const point = this.positionCalculator.calculate(e);
    if (this.firstClick) {
      this.firstClick = false;
      this.arc = new Arc();
      this.arc.position.copy(point).setY(0);
      this.drawings.canvas.add(this.arc);
    }
    this.arc.updateMatrixWorld();
    this.arc.worldToLocal(point);
    this.arc.addPoint(new THREE.Vector2(point.x, point.z));
    this.firstClick = !this.arc.canAddPoint();
    return true;
  }

  disable() {
    this.arc = undefined;
    this.firstClick = true;
    super.disable();
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/components/DrawArcComponent.ts